import ImageWithFallback from '../../common/ImageWithFallback';
import type HeroBannerType from '../../../../types/HeroBanner';
import { PromotionType } from '../../../core/constants';
import analytics from '../../../core/analytics/analytics';
import CircleRight from '../../common/Icons/CircleRight';
import tailwindConfig from '../../../../tailwind.config';
import Button from '../../common/Button/Button';

type Props = {
  heroBanner?: HeroBannerType;
};

const MobileHeroBanner = ({ heroBanner }: Props) => {
  const events = {
    onClick: (banner?: HeroBannerType) => {
      analytics.google.ecommerce.track.promotion.view(
        {
          promotion_name: PromotionType.HERO_BANNER,
          promotion_id: banner?.url || '',
        },
        [
          {
            item_id: banner?.url || '',
            item_name: banner?.mobileContentImage?.altText || '',
          },
        ]
      );
    },
  };

  return (
    <div className="relative h-[600px] w-full">
      <ImageWithFallback
        data-testid="mobile-hero-banner-image"
        className="z-0 rounded-b-2xl"
        alt={heroBanner?.mobileContentImage?.altText || 'mobile-hero-banner-image'}
        src={heroBanner?.mobileContentImage?.url || '/fallback-img-3704x2304.png'}
        layout="fill"
        objectFit="cover"
        fallbackSrc="/fallback-img-3704x2304.png"
      />
      {heroBanner?.description && heroBanner?.url && (
        <div className="absolute top-[350px] z-10 flex w-full justify-center">
          <Button
            className="flex h-10 w-fit max-w-full items-center gap-2 bg-black/60 pl-4 pr-2 text-white hover:opacity-90"
            rounded
            to={heroBanner.url}
            onClick={() => events.onClick(heroBanner)}
          >
            <p className="line-clamp-1 text-regular font-medium">{heroBanner.description}</p>
            <div className="w-6">
              <CircleRight size={24} color={tailwindConfig.theme.colors.white} />
            </div>
          </Button>
        </div>
      )}
    </div>
  );
};

export default MobileHeroBanner;
